import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MachineFile } from '../../_models/machinaries/machineFile';
import { Equipment } from '../../_models';
import { environment } from '../../../../environments/environment';

@Injectable()
export class MachineFileService {
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  receivedFiles: MachineFile[];
  sentFiles: MachineFile[];

  constructor(private http: HttpClient) {
    this.receivedFiles = [];
    this.sentFiles = [];
  }

  getReceivedFiles(equipment: Equipment) {
    // TODO: implement service here
    return this.receivedFiles;
  }

  getSentFiles(equipment: Equipment) {
    // TODO: implement service here
    return this.sentFiles;
  }

  getTaskList(externalSource, externalId, dateFrom, dateTo) {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/' +
          externalSource +
          '/' +
          externalId +
          '/taskDataInfo?' +
          'dateFrom=' +
          dateFrom +
          '&dateTo=' +
          dateTo
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
